import React, { useEffect, useState } from 'react';
import { AuthService } from 'app/services';
import history from '@history';
import { logoutUser, setUserData } from './store/user.slice';
import { useDispatch, useSelector } from 'react-redux';
import LoginPage from '../main/login/LoginPage';
import { AppState } from '../store';
import { getAccount } from 'app/account/store/get-account.slice';

import { Router } from 'react-router-dom';
import ForgotPassword from 'app/main/login/ForgotPassword';
import ResetPassword from 'app/main/login/ResetPassword';
import InternalSalesList from 'app/main/shared-components/sales-table/InternalSalesList';

interface AuthProps {
  children?: React.ReactNode;
}

const Auth = ({ children }: AuthProps) => {
  const dispatch = useDispatch();
  const account = useSelector((state: AppState) => state.account.account);
  const [waitAuthCheck, setWaitAuthCheck] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [currentPath, setCurrentPath] = useState(history.location.pathname);

  const stateUser = useSelector((state: AppState) => state.auth.user);
  const user = AuthService.handleAuthentication();

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setCurrentPath(location.pathname);
    });
    return () => unlisten();
  }, []);

  useEffect(() => {
    // Skip auth check for internal route
    if (currentPath === '/_dummy/test_test') {
      setAuthenticated(false);
      setWaitAuthCheck(false);
      return;
    }

    if (!user) {
      dispatch(logoutUser());
      setAuthenticated(false);
      setWaitAuthCheck(false);

      if (currentPath !== '/forgot-password' && currentPath !== '/reset-password') {
        history.push('/login');
      }
    } else if (!stateUser) {
      dispatch(
        setUserData({
          user,
          callback: () => {
            setAuthenticated(true);
            setWaitAuthCheck(false);
          },
        })
      );
      dispatch(getAccount());
    } else {
      setAuthenticated(true);
      setWaitAuthCheck(false);
    }
  }, [user, stateUser, dispatch, currentPath]);

  if (waitAuthCheck || account.loading) {
    return <p className="p-10"></p>;
  }

  return (
    <Router history={history}>
      {/* Public routes - no authentication required */}
      {currentPath === '/forgot-password' && <ForgotPassword />}
      {currentPath.startsWith('/reset-password') && <ResetPassword />}
      {currentPath === '/_dummy/test_test' && <InternalSalesList />}

      {/* Protected routes */}
      {!authenticated &&
        currentPath !== '/forgot-password' &&
        currentPath !== '/reset-password' &&
        currentPath !== '/_dummy/test_test' && <LoginPage />}

      {/* Authenticated children */}
      {authenticated && children}
    </Router>
  );
};

export default Auth;

